module.exports = __webpack_public_path__ + "img/bgEntryPhysicalExamination.3cc95e8c.png";